import React from 'react';
import PropTypes from 'prop-types';
import StylePropType from 'react-style-proptype';
import Radium from 'radium';
import Styles from './styles';
import Spacer from '../Spacer';

const AccessoryToolbar = props => (
  <div
    style={[
      Styles.wrapper,
      props.style,
      props.active ? { ...Styles.activeStyle, ...props.activeStyle } : {},
    ]}
  >
    {props.leftAccessory}
    <Spacer />
    {props.rightAccessory}
  </div>
);

AccessoryToolbar.propTypes = {
  style: StylePropType,
  active: PropTypes.bool,
  activeStyle: StylePropType,
  leftAccessory: PropTypes.element,
  rightAccessory: PropTypes.element,
};

AccessoryToolbar.defaultProps = {
  style: {},
  active: false,
  activeStyle: {},
  leftAccessory: null,
  rightAccessory: null,
};

export default Radium(AccessoryToolbar);



// WEBPACK FOOTER //
// ./src/components/AccessoryToolbar/index.js